class Tix02Switch extends HTMLElement {
    constructor() {
        super();
        this._internals = this.attachInternals();
        this.addEventListener('click', this._onClick.bind(this));
        this._internals.role = 'checkbox';
        this._internals.ariaChecked = 'false';
        const shadow = this.attachShadow({ mode: 'open' });
        const wrapper = this.getMarkup();
        const styles = this.getStyles();
        shadow.appendChild(styles);
        shadow.appendChild(wrapper);
    }
    get form() {
        return this._internals.form;
    }
    get name() {
        return this.getAttribute('name');
    }
    get type() {
        return this.localName;
    }
    get value() {
        return this.getAttribute('value');
    }
    get checked() {
        return this.hasAttribute('checked');
    }
    set checked(flag) {
        this.toggleAttribute('checked', Boolean(flag));
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this._internals.setFormValue(this.checked ? 'on' : null);
        this._internals.ariaChecked = this.checked ? 'true' : 'false';
    }
    _onClick() {
        this.checked = !this.checked;
    }
    getMarkup() {
        const innerEl = document.createElement('span');
        innerEl.classList.add('-inner');
        const buttonEl = document.createElement('span');
        buttonEl.classList.add('-btn');
        innerEl.appendChild(buttonEl);
        const trackEl = document.createElement('span');
        trackEl.classList.add('-track');
        innerEl.appendChild(trackEl);
        const switchEl = document.createElement('div');
        switchEl.classList.add('-tix02-switch');
        switchEl.appendChild(innerEl);
        return switchEl;
    }
    getStyles() {
        const style = document.createElement('style');
        style.textContent = `
	  :host {
		display:inline-block;
		width:var(--uix-switch-width, 48px);
		height:var(--uix-switch-height, 24px);
		aspect-ratio:2 / 1;
		accent-color: auto;
	  }

	  :host([disabled]) {
		pointer-events:none;
		cursor:defaut;
		opacity:.5;
	  }
	  
	  :host * {
		margin:0;
		border:0;
		padding:0;
		box-sizing:border-box;
		
	  }
	  
	  .-tix02-switch,
	  .-inner,
	  .-btn:before,
	  .-track {
		width:100%;
		height:100%;
	  }

	  .-tix02-switch {
		display:block;
		cursor:pointer;
	  }

	  .-inner,
	  .-track {
		display:block;
	  }

	  .-inner {
		position:relative;
		pointer-events:none;
	  }


	  .-btn,
	  .-track {
		position:absolute;
		top:50%;
		left:0;
	  }

	  .-track {
		height:var(--uix-switch-track-height, 100%);
		background-color: var(--uix-switch-track-color, currentcolor);
		transition:background-color .25s;
		z-index:0;
		translate: 0 -50%;
		border-radius: 100px;
		opacity:.5;
	  }

	  .-btn {
		z-index:1;
		width:var(--uix-switch-height);
		height:var(--uix-switch-height);
		aspect-ratio: 1 / 1;
		border:var(--uix-switch-button-border-width, 2px) solid var(--uix-switch-button-border-color, currentcolor);
		background-color:var(--uix-switch-button-color, #fff);
		transition:all .25s ease;
		border-radius: 100%;
		translate:0 -50%;
	  }

	  :host([checked]) .-btn {
		left:100%;
		background-color: var(--uix-switch-active-button-color, currentcolor);
		translate:-100% -50%;
		box-shadow:3px 3px 12px rgba(0, 0, 0, .08);
	  }
	  
	  :host([checked]) .-track {
	    background-color: var(--uix-switch-active-track-color, currentcolor);
	  }
	  
	  :host([checked]) .-track:before {
		  opacity:1;
	  }
	`;
        return style;
    }
}
Tix02Switch.formAssociated = true;
Tix02Switch.observedAttributes = ['checked'];
customElements.define('uix-switch', Tix02Switch);
export default Tix02Switch;
